import { AppointmentBookedBy, AppointmentStatus, TransportPrincipalType } from '@enums/transport.enum';
import { TransportAddress } from './transport-address.dto';

/**
 * Detalle de un extremo de cita (recogida o entrega)
 */
export class AppointmentSideDto {
    status: AppointmentStatus;
    date: string | null;
    time_from: string | null;
    time_to: string | null;
    booked_by: AppointmentBookedBy | null;
    booked_at: string | null;
    notes: string;
    contact_email: string;
    email_sent_at: string | null;
    expires_at: string | null;
    min_selectable_datetime?: string | null;
    max_selectable_datetime?: string | null;

    constructor(data: any = {}) {
        this.status = data.status || AppointmentStatus.PENDING;
        this.date = data.date ?? null;
        this.time_from = data.time_from ?? null;
        this.time_to = data.time_to ?? null;
        this.booked_by = data.booked_by ?? null;
        this.booked_at = data.booked_at ?? null;
        this.notes = data.notes ?? '';
        this.contact_email = data.contact_email ?? '';
        this.email_sent_at = data.email_sent_at ?? null;
        this.expires_at = data.expires_at ?? null;
        this.min_selectable_datetime = data.min_selectable_datetime ?? null;
        this.max_selectable_datetime = data.max_selectable_datetime ?? null;
    }

    static fromJson(json: any): AppointmentSideDto {
        return new AppointmentSideDto(json);
    }
}

/**
 * Bloque `appointment` devuelto en el detalle del transporte (`transports/{id}/`)
 */
export class AppointmentBlockDto {
    status: AppointmentStatus | null;
    pickup: AppointmentSideDto | null;
    delivery: AppointmentSideDto | null;

    constructor(data: any = {}) {
        this.status = data.status ?? null;
        this.pickup = data.pickup ? AppointmentSideDto.fromJson(data.pickup) : null;
        this.delivery = data.delivery ? AppointmentSideDto.fromJson(data.delivery) : null;
    }

    static fromJson(json: any): AppointmentBlockDto {
        return new AppointmentBlockDto(json);
    }
}

/**
 * Respuesta completa de consulta para el modal de citas (`GET /transports/{id}/appointment/`)
 */
export class TransportAppointmentAdminDto {
    transport_id: number;
    transport_principal_type: TransportPrincipalType;
    kilometers: number;
    duration: number;
    price: number;
    origin_address: TransportAddress | null;
    destination_address: TransportAddress | null;
    status: AppointmentStatus | null;
    pickup: AppointmentSideDto | null;
    delivery: AppointmentSideDto | null;

    constructor(data: any = {}) {
        this.transport_id = data.transport_id ?? 0;
        this.transport_principal_type = data.transport_principal_type ?? TransportPrincipalType.SIMPLE_MOVEMENT;
        this.kilometers = typeof data.kilometers === 'number' ? data.kilometers : parseFloat(data.kilometers || 0);
        this.duration = typeof data.duration === 'number' ? data.duration : parseFloat(data.duration || 0);
        this.price = typeof data.price === 'number' ? data.price : parseFloat(data.price || 0);
        this.origin_address = data.origin_address ? TransportAddress.fromJson(data.origin_address) : null;
        this.destination_address = data.destination_address ? TransportAddress.fromJson(data.destination_address) : null;
        this.status = data.status ?? null;
        this.pickup = data.pickup ? AppointmentSideDto.fromJson(data.pickup) : null;
        this.delivery = data.delivery ? AppointmentSideDto.fromJson(data.delivery) : null;
    }

    static fromJson(json: any): TransportAppointmentAdminDto {
        return new TransportAppointmentAdminDto(json);
    }
}

/**
 * Payload de entrada para fijar (POST) o modificar (PATCH) citas por el administrador
 */
export class AdminAppointmentInputDto {
    pickup_date?: string | null = null;
    pickup_time_from?: string | null = null;
    pickup_time_to?: string | null = null;
    delivery_date?: string | null = null;
    delivery_time_from?: string | null = null;
    delivery_time_to?: string | null = null;
    notes?: string | null = null;

    constructor(data: Partial<AdminAppointmentInputDto> = {}) {
        this.pickup_date = data.pickup_date ?? null;
        this.pickup_time_from = data.pickup_time_from ?? null;
        this.pickup_time_to = data.pickup_time_to ?? null;
        this.delivery_date = data.delivery_date ?? null;
        this.delivery_time_from = data.delivery_time_from ?? null;
        this.delivery_time_to = data.delivery_time_to ?? null;
        this.notes = data.notes ?? null;
    }
}

/**
 * Respuesta del endpoint de reenvío de email
 */
export interface ResendAppointmentEmailResponseDto {
    email_sent_at: string;
}

